import ApplicationsPage from "./applications";
import ApplyPage from "./applications/apply";
import ApplicationViewPage from "./applications/view";
import DashboardPage from "./dashboard";
import ErrorPage from "./error";
import LoginPage from "./user/login";
import MyAccountPage from "./user/view";

const appRoutes = [
  {
    name: "Dashboard Page",
    key: "dashboard",
    route: "/dashboard",
    component: <DashboardPage />,
    secure: true,
  },
  {
    name: "Apply Page",
    key: "apply",
    route: "/apply",
    component: <ApplyPage />,
    secure: true,
  },
  {
    name: "Applications Page",
    key: "applications",
    route: "/applications",
    component: <ApplicationsPage />,
    secure: true,
  },
  {
    name: "Applications View Page",
    key: "application-view",
    route: "/applications/:ref",
    component: <ApplicationViewPage />,
    secure: true,
  },
  {
    name: "Profile",
    key: "account-view",
    route: "/account",
    component: <MyAccountPage />,
    secure: true,
  },
  {
    name: "Login Page",
    key: "login",
    route: "/login",
    component: <LoginPage />,
    secure: false,
  },
  {
    name: "Error Page",
    key: "error",
    route: "/error",
    component: <ErrorPage />,
    secure: false,
  },
];

export default appRoutes;
